const profile = {
    name: 'Jméno',
    avatar: 'Profilový obrázek',
    givenName: 'Křestní jméno',
    familyName: 'Příjmení',
    middleName: 'Druhé jméno',
    fullname: 'Celé jméno',
    nickname: 'Přezdívka',
    preferredUsername: 'Preferované uživatelské jméno',
    profile: 'Profil',
    website: 'Webová stránka',
    gender: 'Pohlaví',
    birthdate: 'Datum narození',
    zoneinfo: 'Časové pásmo',
    locale: 'Region',
    address: {
        formatted: 'Adresa',
        streetAddress: 'Název ulice',
        locality: 'Město',
        region: 'Kraj',
        postalCode: 'PSČ',
        country: 'Země',
    },
    gender_options: {
        female: 'Žena',
        male: 'Muž',
        prefer_not_to_say: 'Nechci uvádět',
    },
    checkbox_value: {
        checked: 'Ano',
        unchecked: 'Ne',
    },
};
export default Object.freeze(profile);
